import styled from '@emotion/styled';
import { Dialog, type DialogProps } from '@mui/material';
import mediaQuery from '@/lib/styling/mediaQuery';
import stripProps from '@/lib/stripProps';

type DialogWithDangerousHandlingProps = DialogProps & {
  dangerous?: boolean;
};

const DialogWithDangerousHandling = styled(
  stripProps(Dialog, 'dangerous'),
)<DialogWithDangerousHandlingProps>(
  {
    '.MuiDialog-container': {
      [mediaQuery(640)]: {
        alignItems: 'flex-end !important',
      },
    },
  },
  ({ theme, dangerous }) => {
    if (!dangerous) {
      return null;
    }

    return {
      '.MuiPaper-root': {
        borderLeft: `4px solid transparent`,
        borderLeftColor: theme.palette.error.main,
        [mediaQuery(640)]: {
          borderLeft: 'none',
        },
      },
    };
  },
);

export default DialogWithDangerousHandling;
